/**
 * Módulo: Assistência Técnica - Mapa e Busca
 */

export default function initMapaAssistencia() {
    const mapContainer = document.getElementById('js-map');
    const form = document.getElementById('js-form-map');

    // Se não estivermos na página correta, aborta a execução
    if (!mapContainer || !form) return;

    // Elementos de UI
    const searchWrapper = document.getElementById('js-search-wrapper');
    const searchLoading = document.getElementById('js-search-loading');
    const resultsSummary = document.getElementById('js-results-summary');
    const summaryText = document.getElementById('js-summary-text');
    const btnReset = document.getElementById('js-btn-reset');

    // Variáveis de escopo do mapa
    let map;
    let markers = [];
    let infoWindow;
    const centroBrasil = { lat: -14.2350, lng: -51.9253 };

    const selectEstado = document.getElementById('estado');
    const selectCidade = document.getElementById('cidade');

    /**
     * Lida com a mudança de estado e carrega as cidades filhas via API
     */
    if (selectEstado && selectCidade) {
        selectEstado.addEventListener('change', async (event) => {
            const estadoSlug = event.target.value;

            // Reseta o select de cidade
            selectCidade.innerHTML = '<option value="">Selecione a cidade</option>';
            selectCidade.disabled = true;

            if (!estadoSlug) return;

            selectCidade.innerHTML = '<option value="">Carregando...</option>';

            try {
                const response = await fetch(`/wp-json/pdr/v1/cidades?estado=${estadoSlug}`);
                if (!response.ok) throw new Error('Erro ao buscar cidades');

                const cidades = await response.json();

                selectCidade.innerHTML = '<option value="">Selecione a cidade</option>';

                if (cidades.length > 0) {
                    cidades.forEach(cidade => {
                        selectCidade.innerHTML += `<option value="${cidade.slug}">${cidade.nome}</option>`;
                    });
                    selectCidade.disabled = false;
                } else {
                    selectCidade.innerHTML = '<option value="">Nenhuma cidade cadastrada</option>';
                }
            } catch (error) {
                console.error(error);
                selectCidade.innerHTML = '<option value="">Erro ao carregar</option>';
            }
        });
    }

    /**
     * Inicializa o Google Maps
     */
    function instanciarMapa() {
        // Aguarda a disponibilidade do objeto google no window
        if (typeof window.google === 'undefined') {
            console.error('Google Maps API não carregada.');
            return;
        }

        map = new window.google.maps.Map(mapContainer, {
            center: centroBrasil,
            zoom: 4,
            disableDefaultUI: true,
            zoomControl: true,
            styles: []
        });

        infoWindow = new window.google.maps.InfoWindow({
            minWidth: 320
        });

        window.google.maps.event.addListener(infoWindow, 'closeclick', () => {
            if (resultsSummary) resultsSummary.classList.remove('--is-faded');
        });

        map.addListener('click', () => {
            infoWindow.close();
            if (resultsSummary) resultsSummary.classList.remove('--is-faded');
        });
    }

    /**
     * Limpa os pins atuais do mapa
     */
    function limparMarkers() {
        markers.forEach(marker => marker.setMap(null));
        markers = [];
    }

    /**
     * Adiciona os novos pins e enquadra o mapa
     * @param {Array} locais 
     */
    function plotarMarkers(locais) {
        limparMarkers();

        if (locais.length === 0) {
            return;
        }

        const bounds = new window.google.maps.LatLngBounds();

        const customIcon = {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent('<svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.3322 51.9962C7.75987 42.4239 7.75987 26.9042 17.3322 17.3319V17.3319C26.9045 7.7596 42.4242 7.7596 51.9965 17.3319V17.3319C61.5688 26.9042 61.5688 42.4239 51.9965 51.9962L36.8309 67.1619C35.6343 68.3584 33.6944 68.3584 32.4978 67.1619L17.3322 51.9962Z" fill="#182579"/><circle cx="35" cy="34.998" r="11" fill="white"/></svg>'),
            scaledSize: new window.google.maps.Size(35, 35),
            anchor: new window.google.maps.Point(17.5, 34)
        };

        locais.forEach(local => {
            const lat = parseFloat(local.lat);
            const lng = parseFloat(local.lng);

            if (isNaN(lat) || isNaN(lng)) return;

            const position = { lat, lng };

            const marker = new window.google.maps.Marker({
                position: position,
                map: map,
                title: local.titulo,
                icon: customIcon
            });

            const telefonesHTML = local.telefone && local.telefone.length > 0
                ? local.telefone.map(tel => {
                    const telLink = tel.replace(/[^\d+]/g, '');
                    return `
                    <div class="c-info-window__item c-info-window__item--tel">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#FFB800" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                        <a href="tel:${telLink}">${tel}</a>
                    </div>`;
                }).join('')
                : '';

            const emailsHTML = local.email && local.email.length > 0
                ? local.email.map(mail => `
                    <div class="c-info-window__item c-info-window__item--email">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#FFB800" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                        <a href="mailto:${mail}">${mail}</a>
                    </div>`).join('')
                : '';

            const contentString = `
                <div class="c-info-window">
                    <h3 class="c-info-window__city">${local.cidade || ''}</h3>
                    <p class="c-info-window__title">${local.titulo}</p>
                    ${local.logradouro ? `<p class="c-info-window__text">${local.logradouro}${local.numero ? ', N°' + local.numero : ''}</p>` : ''}
                    ${local.bairro ? `<p class="c-info-window__text">Bairro: ${local.bairro}</p>` : ''}
                    <hr class="c-info-window__divider">
                    ${telefonesHTML}
                    ${emailsHTML}
                    <a href="https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}" target="_blank" class="c-info-window__link">Abrir no Google Maps</a>
                </div>
            `;

            marker.addListener('click', () => {
                infoWindow.setContent(contentString);
                infoWindow.open(map, marker);
                if (resultsSummary) resultsSummary.classList.add('--is-faded');
            });

            markers.push(marker);
            bounds.extend(position);
        });

        if (markers.length > 0) {
            const isMobile = window.innerWidth < 768;

            map.fitBounds(bounds, {
                top: isMobile ? 250 : 80,
                bottom: 40,
                left: 40,
                right: 40
            });

            const listener = window.google.maps.event.addListener(map, 'idle', () => {
                if (map.getZoom() > 15) {
                    map.setZoom(15);
                }
                window.google.maps.event.removeListener(listener);
            });
        }
    }

    /**
     * Alterna o estado da interface (Buscando -> Resultado)
     * @param {boolean} buscando 
     */
    function setEstadoLoading(buscando) {
        if (buscando) {
            searchLoading.classList.remove('--is-hidden');
        } else {
            searchLoading.classList.add('--is-hidden');
            searchWrapper.classList.add('--is-hidden');
            resultsSummary.classList.remove('--is-hidden');
        }
    }

    async function handleSubmit(event) {
        event.preventDefault();
        setEstadoLoading(true);

        const formData = new FormData(form);
        const estado = formData.get('estado');
        const cidade = formData.get('cidade');
        const especialidade = formData.get('especialidade');

        const params = new URLSearchParams();
        if (estado) params.append('estado', estado);
        if (cidade) params.append('cidade', cidade);
        if (especialidade) params.append('especialidade', especialidade);

        try {
            const response = await fetch(`/wp-json/pdr/v1/assistencias?${params.toString()}`);

            if (!response.ok) {
                throw new Error('Erro na comunicação com a API');
            }

            const data = await response.json();

            const selectEstado = document.getElementById('estado');
            const selectCidade = document.getElementById('cidade');
            const selectEspecialidade = document.getElementById('especialidade');

            let resumoHTML = `
                <div class="c-results-summary__header">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.9873 9.99365C19.9873 14.9839 14.4513 20.181 12.5924 21.7862C12.4192 21.9164 12.2084 21.9868 11.9917 21.9868C11.775 21.9868 11.5642 21.9164 11.391 21.7862C9.53205 20.181 3.99609 14.9839 3.99609 9.99365C3.99609 7.87308 4.83848 5.83937 6.33796 4.33991C7.83742 2.84043 9.87113 1.99805 11.9917 1.99805C14.1122 1.99805 16.146 2.84043 17.6455 4.33991C19.1449 5.83937 19.9873 7.87308 19.9873 9.99365Z" stroke="#FFA100" stroke-width="1.9989" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M11.9944 12.9928C13.6504 12.9928 14.9928 11.6504 14.9928 9.99444C14.9928 8.33851 13.6504 6.99609 11.9944 6.99609C10.3385 6.99609 8.99609 8.33851 8.99609 9.99444C8.99609 11.6504 10.3385 12.9928 11.9944 12.9928Z" stroke="#FFA100" stroke-width="1.9989" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span>Resultados da busca:</span>
                </div>
            `;

            if (cidade) resumoHTML += `<p class="c-results-summary__text"><strong>Cidade:</strong> ${selectCidade.options[selectCidade.selectedIndex].text}</p>`;
            if (estado) resumoHTML += `<p class="c-results-summary__text"><strong>Estado:</strong> ${selectEstado.options[selectEstado.selectedIndex].text}</p>`;
            if (especialidade) resumoHTML += `<p class="c-results-summary__text"><strong>Especialidade:</strong> ${selectEspecialidade.options[selectEspecialidade.selectedIndex].text}</p>`;

            summaryText.innerHTML = resumoHTML;

            plotarMarkers(data);
            setEstadoLoading(false);

        } catch (error) {
            console.error(error);
            alert('Ocorreu um erro ao buscar as assistências. Tente novamente.');
            searchLoading.classList.add('--is-hidden');
        }
    }

    /**
     * Lida com o botão "Nova Busca" (Reset)
     */
    function handleReset() {
        form.reset();
        limparMarkers();

        if (infoWindow) infoWindow.close();

        map.setCenter(centroBrasil);
        map.setZoom(4);

        resultsSummary.classList.add('--is-hidden');
        resultsSummary.classList.remove('--is-faded');
        searchWrapper.classList.remove('--is-hidden');
    }

    // Bind de Eventos
    form.addEventListener('submit', handleSubmit);
    if (btnReset) btnReset.addEventListener('click', handleReset);

    setTimeout(instanciarMapa, 500);
}